// Curated sign-in hero presets. Each sets the login-only colours
// (loginPrimaryColor = the bright glow, loginAccentColor = the mid tone of
// the radial+linear gradient the LoginPage builds). They never touch the
// in-app theme primary. Owners can still hand-pick any colour.
export interface LoginPreset {
  id: string;
  name: string;
  primary: string;
  accent: string;
}

export const LOGIN_PRESETS: LoginPreset[] = [
  { id: 'ocean', name: 'Ocean', primary: '#0c87f0', accent: '#dcc9a8' },
  { id: 'indigo', name: 'Indigo', primary: '#6366f1', accent: '#c7b8ea' },
  { id: 'emerald', name: 'Emerald', primary: '#10b981', accent: '#064e3b' },
  { id: 'teal', name: 'Teal', primary: '#14b8a6', accent: '#0b3b3b' },
  { id: 'sunset', name: 'Sunset', primary: '#f97316', accent: '#7c2d12' },
  { id: 'rose', name: 'Rose', primary: '#f43f5e', accent: '#4c0519' },
  { id: 'violet', name: 'Violet', primary: '#8b5cf6', accent: '#2e1065' },
  { id: 'slate', name: 'Slate', primary: '#38bdf8', accent: '#1e293b' },
];

/** The same radial+linear gradient the LoginPage hero builds, for swatches. */
export const loginHeroGradient = (primary: string, accent: string): string =>
  `radial-gradient(85% 120% at 85% 85%, ${primary} 0%, ${accent} 40%, #001a3a 85%, #000a1a 100%), linear-gradient(135deg, #000a1a 0%, ${accent} 60%, ${primary} 100%)`;
